import httpRequest from './httpRequest';
import { getBaseRequestConfig, LOCAL_BASE_PATH } from './baseRequestConfig';

export function postIndividual(individual) {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/individual`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: individual,
  });

  return httpRequest(requestConfig);
}
